import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import AdCardCompact from '../components/ads/AdCardCompact';

interface Ad {
  id: number; title: string; description: string; price: string; price_type: string;
  status: string; views_count: number; favorites_count: number;
  category: { id: number; name_ar: string } | null;
  city?: { name_ar: string } | null;
  images: { image_url: string; thumbnail_url: string | null; is_primary: boolean }[];
  published_at: string; created_at: string;
}

const FavoritesPage: React.FC = () => {
  const [ads, setAds] = useState<Ad[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();
  const hasToken = Boolean(localStorage.getItem('user'));

  useEffect(() => {
    if (!hasToken) { navigate('/login'); return; }
    const fetch = async () => {
      try {
        setLoading(true);
        const res = await api.get('/favorites', { params: { page, per_page: 20 } });
        const d = res.data.data;
        setAds(d.ads || []);
        setLastPage(d.pagination?.last_page || 1);
        setTotal(d.pagination?.total || 0);
      } catch (e) { console.error(e); } finally { setLoading(false); }
    };
    fetch();
  }, [hasToken, page, navigate]);

  const removeFav = async (adId: number) => {
    try {
      await api.delete('/favorites/' + adId);
      setAds(prev => prev.filter(a => a.id !== adId));
      setTotal(prev => prev - 1);
    } catch (e) { console.error(e); }
  };

  if (loading) return (
    <div style={{ padding: '60px 16px', textAlign: 'center', fontFamily: 'var(--aj-font)', color: 'var(--aj-muted)' }}>جاري التحميل...</div>
  );

  return (
    <div style={{ fontFamily: 'var(--aj-font)' }}>
      <div style={{ marginBottom: 18 }}>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--aj-primary-dark)', margin: 0 }}>❤️ المفضلة</h1>
        {total > 0 && <p style={{ fontSize: 13, color: 'var(--aj-muted)', margin: '4px 0 0' }}>{total} إعلان</p>}
      </div>

      {ads.length === 0 ? (
        <div style={{ background: '#fff', borderRadius: 14, border: '1px solid var(--aj-border)', padding: '60px 20px', textAlign: 'center' }}>
          <span style={{ fontSize: 44 }}>❤️</span>
          <p style={{ color: 'var(--aj-muted)', fontSize: 15, marginTop: 12 }}>لا توجد إعلانات في المفضلة</p>
          <Link to="/ads" style={{ display: 'inline-block', marginTop: 16, padding: '10px 24px', background: 'var(--aj-primary)', color: '#fff', borderRadius: 10, textDecoration: 'none', fontSize: 14, fontWeight: 700 }}>تصفّح الإعلانات</Link>
        </div>
      ) : (
        <div className="ajc-list">
          {ads.map(ad => (
            <AdCardCompact key={ad.id} ad={ad} onFav={removeFav} favActive />
          ))}
        </div>
      )}

      {lastPage > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 20 }}>
          <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid var(--aj-border)', background: '#fff', fontFamily: 'var(--aj-font)', fontSize: 13, opacity: page === 1 ? 0.5 : 1, cursor: page === 1 ? 'default' : 'pointer' }}>السابق</button>
          <span style={{ padding: '8px 12px', fontSize: 13, color: 'var(--aj-text-2)' }}>{page} / {lastPage}</span>
          <button onClick={() => setPage(p => Math.min(lastPage, p + 1))} disabled={page === lastPage} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid var(--aj-border)', background: '#fff', fontFamily: 'var(--aj-font)', fontSize: 13, opacity: page === lastPage ? 0.5 : 1, cursor: page === lastPage ? 'default' : 'pointer' }}>التالي</button>
        </div>
      )}
    </div>
  );
};

export default FavoritesPage;
